import request from './axios';

type CapitalizeWords<S extends string> = S extends `${infer T}-${infer U}`
  ? `${Capitalize<T>}${CapitalizeWords<U>}`
  : Capitalize<S>;

type CRUDOps<T, Entity extends string> = {
  [K in
    | `get${CapitalizeWords<Entity>}`
    | `get${CapitalizeWords<Entity>}ById`
    | `create${CapitalizeWords<Entity>}`
    | `update${CapitalizeWords<Entity>}`
    | `delete${CapitalizeWords<Entity>}`]: K extends `update${CapitalizeWords<Entity>}`
    ? (id: number, data: T) => Promise<T>
    : K extends `get${CapitalizeWords<Entity>}`
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params?: Record<string, any>) => Promise<T>
      : K extends
            | `get${CapitalizeWords<Entity>}ById`
            | `delete${CapitalizeWords<Entity>}`
        ? (id: number) => Promise<T>
        : K extends `create${CapitalizeWords<Entity>}`
          ? (data: T) => Promise<T>
          : () => Promise<T>;
};

const getRequestWithFilters = (queryParams: QueryParamsType, url: string) => {
  const { filters } = queryParams || {};
  console.log(filters, url);
  let newUrl: string = url;

  if (filters && Object.keys(filters).length > 0) {
    const queryParams = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        const paramValue = Array.isArray(value) ? value.join(',') : value;
        return `${encodeURIComponent(key)}=${encodeURIComponent(paramValue)}`;
      })
      .join('&');
    newUrl = `${newUrl}?${queryParams}`;
  }
  /* We can do rest of stuff like overriding/adding pagination, etc*/
  return request.get(newUrl).then((response) => response.data);
};

const generateCRUDOps = <T, Entity extends string>(
  basePath: string,
  entity: Entity
): CRUDOps<T, Entity> => {
  const url = `${basePath}${entity}/`;
  const words = entity.split('-');
  const funcName = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

  return {
    [`get${funcName}`]: (queryParams?: QueryParamsType) =>
      getRequestWithFilters(queryParams, url),
    [`get${funcName}ById`]: (id: number) =>
      request.get(`${url}${id}/`).then((response) => response.data),
    [`create${funcName}`]: (data: T) =>
      request.post(url, data).then((response) => response.data),
    [`update${funcName}`]: (id: number, data: T) =>
      request.patch(`${url}${id}/`, data).then((response) => response.data),
    [`delete${funcName}`]: (id: number) =>
      request.delete(`${url}${id}/`).then((response) => response.data),
  } as CRUDOps<T, Entity>;
};

export default generateCRUDOps;
